import { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { markApplicationSubmitted } from "store/application/applicationSlice";

/**
 * Marks the application as terminally submitted. Call on mount of every
 * decision (terminal) page so that navigating back into the form pages cannot
 * resubmit the application.
 *
 * The state is intentionally NOT cleared here: the decision pages render from
 * it (name, coverage, policy number), and keeping the persisted copy lets a
 * refresh restore the same details. The flag is whitelisted in the persist
 * config, so the rehydrated state still reports the application as submitted
 * and the in-flow route guard keeps blocking resubmission. The data clears
 * when the tab closes (sessionStorage) or a new application flow resets it.
 */
export const useMarkApplicationSubmitted = (): void => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(markApplicationSubmitted());
    }, [dispatch]);
};

export default useMarkApplicationSubmitted;
